import { createContext, useContext } from 'react';
export const WalletMenuContext = createContext({
    isWalletMenuOpen: () => { },
    toggleWalletMenu: () => { },
    openWalletMenu: () => { },
    closeWalletMenu: () => { },
});
export const useWalletMenu = () => useContext(WalletMenuContext);
//# sourceMappingURL=WalletMenuContext.js.map